import { FormGroup } from '@angular/forms';

/**
 * Whether a form may be submitted while a uniqueness check is still in flight.
 *
 * `form.valid` is false the whole time an async validator is running, and on a
 * form that submits synchronously that turns a click made a moment too early into
 * "please fill all required fields" — pointing at a form with nothing wrong with
 * it. So a control that is still being asked about counts as passing: whatever the
 * answer turns out to be, the save re-checks it server-side and the field is
 * marked from that answer instead.
 *
 * A control that is genuinely invalid still blocks, which is why this is a walk of
 * the controls rather than `form.valid || form.pending` — a group reports PENDING
 * in preference to INVALID, so one field waiting on the server would otherwise
 * carry every empty required field past the check with it.
 *
 * Disabled controls are skipped, matching how a form's own validity treats them.
 */
export function isSubmittable(form: FormGroup): boolean {
  return Object.values(form.controls).every(
    (control) => control.disabled || control.valid || control.pending,
  );
}
